<template>
  <CHeader fixed with-subheader light class="justify-content-end header">
    <CToggler
      in-header
      class="d-lg-none"
      @click="$store.commit('toggleSidebarMobile')"
    />
    <CToggler
      in-header
      class="d-md-down-none"
      @click="$store.commit('toggleSidebarDesktop')"
    />
    <CHeaderNav class="header__nav-list">
      <CHeaderNavItem>
        <TheHeaderDropdownNotifications />
      </CHeaderNavItem>
      <TheHeaderDropdownAccnt/>
    </CHeaderNav>
  </CHeader>
</template>

<script>
import TheHeaderDropdownAccnt from './TheHeaderDropdownAccnt'
import TheHeaderDropdownNotifications from './TheHeaderDropdownNotifications'

import {
  authStore
} from '@/mixins/authStoreMixin'

export default {
  name: 'TheHeader',

  components: {
    TheHeaderDropdownAccnt,
    TheHeaderDropdownNotifications
  },

  created () {
    this.$store.dispatch(`${authStore.moduleName}/${authStore.actionTypes.ACTION_LOAD_NOTIFICAITONS}`)
  }
}
</script>
